import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import AmenitiesSlide from '../components/AmenitiesSlide'
import AmenitiesSlider from '../components/AmenitiesSlider'
import LayoutContext from './LayoutContext'
import media from 'css-in-js-media'

const AmenitiesWrap = styled.div``

import ZoomIcon from '../svg/arrows-out-simple.svg'
import { Variables } from '../styles/Variables'
import { Tab, TabContent, Tabs, TabsContent, TabsWrap } from './Tabs'
import { BodyCopy } from './Typography'
import Container from './Container'

const ZoomButton = styled.div`
    position: absolute;
    right: 60px;
    top: 40px;
    z-index: 10;
    cursor: pointer;

    ${media('<desktop')} {
        right: 20px;
    }

    svg {
        width: 30px;
        height: 30px;
    }

    svg path {
        stroke: ${Variables.color.white};
    }
`

const StyledTabs = styled(TabsContent)`
    padding-bottom: 120px;
    background-color: ${Variables.color.lightGrey};

    ${Tabs} {
        border: none;
        justify-content: stretch;
        width: 100%;
        margin-top: 60px;
        margin-bottom: 40px;

        ${Tab} {
            &:first-child {
                padding-left: 0;
                justify-content: start;
            }
            &:last-child {
                padding-right: 0;
                justify-content: end;

                ${media('<desktop')} {
                    justify-content: start ;
                }
            }
        }
    }
    ${Tab} {
        flex-grow: 1;
        min-width: auto;
        color: ${Variables.color.pazola};
        font-family: ${Variables.font.body};
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: 0.1em;
        margin: 0;
        border-color: ${Variables.color.pazola} ;
        cursor: pointer;

        ${media('<desktop')} {
            display: none;
            &.active {
                border-width: 1px;
                justify-content: start;
                padding: 0 0 14px 0;
                display: flex;
            }
        }
    }
    ${Container} {
        padding: 0 172px;
        ${media('<desktop')} {
            padding: 0 20px;
        }
    }

    ${BodyCopy} {
        font-family: ${Variables.font.title};
        font-style: normal;
        font-weight: 300;
        font-size: 38px;
        line-height: 44px;

        h2 {
            font-family: ${Variables.font.title};
            font-style: normal;
            font-weight: 300;
            font-size: 38px;
            line-height: 44px;
            margin: 0 ;
            ${media('<desktop')} {
                font-size: 24px;
                line-height: 30px;
            }
        }
        img {
            display: block;
            margin: 0 auto;
        }
        ${media('<desktop')} {
            font-size: 24px;
            line-height: 30px;
        }
    }
`

export const AmenitiesSection: React.FC<{
    data?: object
}> = ({ data }) => {    
    const { amenities, id } = data;
    const [newSlideIdx, setNewSlideIdx] = useState(0);
    const [selectedSlide, setSelectedSlide] = useState(amenities && amenities[newSlideIdx].title);
    const [getAmenitiesSlider, setAmenitiesSlider] = useState()
    const { isSlideshow, setSlideshow, setZoomOpen, ActiveZomSlide } = useContext(LayoutContext)
    const getSlideshowData = () => {
        let newData = []
        data.amenities.map((amenity) => {
            newData = [...newData, { title: amenity.title, fluid: amenity.image.fullSize }]
        })
        return newData
    }

    const activateZoom = (index, id) => {
        setZoomOpen(id)
        if (ActiveZomSlide) {
            ActiveZomSlide.map((s, i) => {
                if (s.id == id) {
                    s.slider.update()
                    s.slider.slideTo(index, 0)
                    setTimeout(() => {
                        s.slider.update()
                    }, 300)
                }
            })
        }
    }

    const onChange = (swiper) => {
        const newIndex = swiper.realIndex;
        setNewSlideIdx(newIndex)
        setSelectedSlide(amenities[newIndex].title);
    }

    useEffect(() => {
        if (isSlideshow.filter((e) => e.id === id).length == 0) {
            setSlideshow((isSlideshow) => [
                ...isSlideshow,
                { id: id, data: { slideshowImages: getSlideshowData(), id: id } },
            ])
        }
    }, [])

    useEffect(() => {        
        if(getAmenitiesSlider) {
            getAmenitiesSlider.slideTo(newSlideIdx, 1500)
        }            
    },[selectedSlide, newSlideIdx])

    return (
        <>
            <AmenitiesWrap>
                <AmenitiesSlider onSlideChange={onChange} onSetAmenitiesSlider={(instance) => setAmenitiesSlider(instance)}>
                    {amenities.map((amenity, i) => (
                        <AmenitiesSlide
                            key={i}
                            title={amenity.title}
                            subtitle={amenity.copy && amenity.copy.copy}
                            image={amenity.image}
                        >
                            <ZoomButton
                                onClick={() => {
                                    activateZoom(i, data.id)
                                }}
                            >
                                <ZoomIcon />
                            </ZoomButton>
                        </AmenitiesSlide>
                    ))}
                </AmenitiesSlider>
            </AmenitiesWrap>
            <StyledTabs>
                <TabsWrap>
                    <Container>
                        <Tabs>
                            {amenities.map((amenity, i) => (
                                <Tab
                                    key={i}
                                    active={selectedSlide == amenity.title ? true : undefined}
                                    className={selectedSlide == amenity.title ? 'active' : null}
                                    onClick={() => {
                                        setSelectedSlide(amenity.title);
                                        setNewSlideIdx(i);                                   
                                    }}
                                >
                                    {amenity.title}
                                </Tab>
                            ))}
                        </Tabs>
                    </Container>
                </TabsWrap>
                {amenities.map((amenity, i) => (
                    <TabContent
                        key={i}
                        active={selectedSlide == amenity.title ? true : undefined}
                    >
                        <Container>
                            <BodyCopy
                                dangerouslySetInnerHTML={{
                                    __html: amenity?.copy?.childMarkdownRemark?.html,
                                }}
                            />
                        </Container>
                    </TabContent>
                ))}
            </StyledTabs>
        </>
    )
}
export default AmenitiesSection
